import React, { useEffect, useState } from 'react';
import { X } from 'lucide-react';
import { useStore } from '../store';
import { ZONES } from '../config/zones';
import { fetchBriefing } from '../api';

// A clean side-card that slides in from the right when an Info Pin is tapped.
export default function SideCard() {
  const idx = useStore((s) => s.activeSideCard);
  const close = useStore((s) => s.closeSideCard);
  const narrateBank = useStore((s) => s.narrateBank);
  const briefings = useStore((s) => s.briefings);
  const setBriefingCache = useStore((s) => s.setBriefingCache);
  const [loading, setLoading] = useState(false);

  const open = idx !== null && idx !== undefined;
  const zone = open ? ZONES[idx] : null;
  const b = zone ? briefings[zone.id] : null;

  useEffect(() => {
    if (!open || !zone || b) return;
    let alive = true;
    setLoading(true);
    fetchBriefing(zone.id)
      .then((data) => { if (alive) setBriefingCache(zone.id, data); })
      .catch(() => {})
      .finally(() => { if (alive) setLoading(false); });
    return () => { alive = false; };
  }, [open, zone && zone.id]);

  return (
    <div
      data-testid="zone-side-card"
      className={`fixed top-0 right-0 h-full w-[86vw] max-w-sm z-[100] pointer-events-auto transition-transform duration-300 ${open ? 'translate-x-0' : 'translate-x-full'}`}
      style={{ background: 'rgba(6,9,15,0.82)', backdropFilter: 'blur(16px)', WebkitBackdropFilter: 'blur(16px)', borderLeft: '1px solid rgba(212,175,55,0.35)', boxShadow: '-12px 0 40px rgba(0,0,0,0.5)' }}
    >
      {zone && (
        <div className="h-full flex flex-col p-6 overflow-y-auto">
          <div className="flex items-start justify-between gap-4">
            <div>
              <div className="font-mono text-[10px] tracking-[0.35em] text-gold">
                ZONE {String(zone.number).padStart(2, '0')} / 10
              </div>
              <h3 className="font-serif text-3xl text-white leading-tight mt-1">{zone.title}</h3>
            </div>
            <button data-testid="side-card-close" onClick={close} className="text-white/50 hover:text-gold transition-colors mt-1">
              <X className="w-6 h-6" />
            </button>
          </div>

          <div className="mt-6 space-y-5">
            <div className="border-l-2 pl-4" style={{ borderColor: '#3B82F6' }}>
              <button data-testid="side-card-liberal" onClick={() => narrateBank('progressive')}
                className="font-mono text-[10px] tracking-widest mb-1.5 text-[#93c5fd] hover:text-[#3B82F6] transition-colors uppercase flex items-center gap-1.5">
                ▶ Liberal · Left Bank
              </button>
              <p className="font-sans text-white/90 text-sm leading-relaxed">{loading && !b ? 'Consulting the field notes…' : (b ? b.progressive : '—')}</p>
            </div>
            <div className="border-l-2 pl-4" style={{ borderColor: '#EF4444' }}>
              <button data-testid="side-card-conservative" onClick={() => narrateBank('traditional')}
                className="font-mono text-[10px] tracking-widest mb-1.5 text-[#fca5a5] hover:text-[#EF4444] transition-colors uppercase flex items-center gap-1.5">
                ▶ Conservative · Right Bank
              </button>
              <p className="font-sans text-white/90 text-sm leading-relaxed">{loading && !b ? 'Consulting the field notes…' : (b ? b.traditional : '—')}</p>
            </div>
          </div>

          <p className="mt-auto pt-6 font-mono text-[9px] uppercase tracking-[0.3em] text-white/30">
            Tap ▶ to hear the Harpy Eagle · tap ✕ to dismiss
          </p>
        </div>
      )}
    </div>
  );
}
